import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  useTheme,
} from "@mui/material";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
// import ChoiceTile, {
//   ChoiceOption,
// } from "@components/ChoiceModalCst/ChoiceTile";
import { ButtonPrimary } from "src/UI/ButtonPrimary";
// import { ButtonTertiary } from "src/UI/ButtonTertiary";

export type LOOutcomeEntityType = "activity" | "course" | "path" | "edition";
export type LOOutcomeMode = "add" | "edit";

interface LOOutcomeModalCstProps {
  open: boolean;
  entityType: LOOutcomeEntityType;
  mode: LOOutcomeMode;
  // associationOptions?: ChoiceOption[];
  // onAssociate?: (key: string) => void;
  onDismiss: () => void;
}

const LOOutcomeModalCst: React.FC<LOOutcomeModalCstProps> = ({
  open,
  entityType,
  mode,
  // associationOptions,
  // onAssociate,
  onDismiss,
}) => {
  const { t } = useTranslation("lo-outcome-modal");
  const theme = useTheme();

  // const hasAssociations =
  //   mode === "add" &&
  //   !!associationOptions &&
  //   associationOptions.length > 0 &&
  //   !!onAssociate;

  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <Box sx={{ paddingTop: "24px" }} />

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          padding: "0 32px 32px",
          textAlign: "center",
        }}
      >
        <CheckCircle2
          size={56}
          strokeWidth={1.75}
          color={theme.palette.text.primary}
        />

        <Typography
          sx={{
            fontSize: "22px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            lineHeight: 1.35,
          }}
        >
          {t(`${entityType}.${mode}`)}
        </Typography>

        {/* {hasAssociations && (
          <>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                width: "100%",
                textAlign: "left",
              }}
            >
              {associationOptions!.map((opt) => (
                <ChoiceTile
                  key={opt.key}
                  option={opt}
                  onSelect={onAssociate!}
                />
              ))}
            </Box>

            <Typography
              sx={{
                fontSize: "13px",
                color: theme.palette.text.tertiary,
              }}
            >
              {t("helper")}
            </Typography>
          </>
        )}

        {hasAssociations ? (
          <ButtonTertiary size="md" onClick={onDismiss}>
            {t("dismiss-with-association")}
          </ButtonTertiary>
        ) : (
          <ButtonPrimary size="md" onClick={onDismiss}>
            {t("dismiss")}
          </ButtonPrimary>
        )} */}

        <ButtonPrimary size="md" onClick={onDismiss}>
          {t("dismiss")}
        </ButtonPrimary>
      </DialogContent>
    </Dialog>
  );
};

export default LOOutcomeModalCst;
